export const tailMisc = {
  tabBottom: {
    checkins: `تسجيلات الوصول`,
    checkinsProg: `القادمة`,
    requests: `الطلبات`,
  },
  adminNav: {
    myAccount: `حسابي`,
  },
  loader: {
    title: `جارٍ إنشاء {reason}!`,
    defaultReason: `الإقامة`,
    preparing: `نجهّز {reason}، يُرجى الانتظار…`,
    calendar: `جارٍ إعداد التقويم`,
    availability: `جارٍ التحقق من التوفّر`,
    prices: `جارٍ إعداد الأسعار`,
    almostDone: `أوشكنا على الانتهاء، نُنهي {reason}…`,
  },
};
